import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import styled from 'styled-components'
//@ts-ignore
import Modal from 'live/components/ui/Modal'
import { useSelector, useDispatch } from 'react-redux'
// components preview

import { FileHistory } from './ListFiles'
import { Database } from '../../../EditDatabase/EditDatabase'
import { getHistoryPreview } from '../../../../../api/preview/edit/getHistoryPreview'
import { ErrorDetailsRows } from '../../../../alerts/StatusResponse'
import { Table } from './Table'
import { ErrorRowHeader, ErrorRow } from '../../../../errors/Row'
import { LoadingIconCenter } from '../../../../main'
import { SpreadsheetHeader, TemplateHeaderPreview } from '../types'
import { getConfigHeader } from './getConfigHeader'

interface Props {
    onlyView?: boolean
    update?: boolean
    database?: string
    model: Database
    getHeader?: boolean
    headers: SpreadsheetHeader[]
    file: FileHistory
    sheets: string[]
    templete?: TemplateHeaderPreview
    sheetSelected: string
    setSheet: (sheet: string) => void
    setDatabase: (database: Database) => void
}

export default function ModalHistoryPreview({
    headers,
    onlyView,
    update = false,
    database,
    getHeader = false,
    file,
    model,
    sheets,
    templete,
    sheetSelected,
    setSheet,
    setDatabase
}: Props) {
    const [finalFile, setFinalFile] = useState({})

    const [loading, setLoading] = useState<boolean>(false)

    const containerRef = useRef(null)

    useMemo(() => {
        if (!!file?.uid && !!file?.collection) {
            if (!loading) {
                setLoading(true)
            }

            getHistoryPreview(file, model?.dateReference)
                .then(obj => setFinalFile(obj))
                .then(() => setLoading(false))
        } else if (file == undefined) {
            setLoading(false)
            setFinalFile({})

        }

        return ''
    }, [file?.uid])

    useEffect(() => {
        // console.log('update file!')
    }, [file?.uid])

    useEffect(() => {
        if (!sheets.includes(sheetSelected) && sheets.length > 0) {
            setSheet(sheets[0])
        }
    }, sheets)
    
    const getFinalHeaders = (): SpreadsheetHeader[] => {

        if (!file) {
            return headers
        } else if (!!templete) {
            const data = templete.sheetData.find(({ sheetName }) => sheetName === sheetSelected)
            if (!!data) {
                return data.header
            }
            return []
        }
        if (!!finalFile?.header) {
            return finalFile['header']
        }
        return []
    }

    const getFinalData = (headers: SpreadsheetHeader[]): object[] => {
        if (!file) {
        } else if (!!templete) {
            const data = templete.sheetData.find(({ sheetName }) => sheetName === sheetSelected)
            if (!!data) {
                return data.rows.map(row => {
                    return row.reduce((status, ev, index) => {
                        return {
                            ...status,
                            [headers[index]?.alias]: String(ev?.parsed)
                        }
                    }, {})
                })
            }
            return []
        }

        if (!!finalFile?.data) {
            return finalFile['data']
        }
        return []
    }

    const getFistError = (): object => {
        if (!!finalFile?.error) {
            return finalFile['error']
        }
        return null
    }

    const getErrorRow = (obj): ErrorDetailsRows[] => {
        const typeError = obj?.type

        if (String(typeError) === 'Rows') {
            return obj['details']
        }
        return null
    }
    const finalHeaders = getFinalHeaders()

    const data = getFinalData(finalHeaders)
    const errorObj = getFistError()

    const errorsRow = getErrorRow(errorObj)
    const headerConfig = getConfigHeader(model)
    return (
        <>
            <div
                ref={containerRef}
                style={{                    
                    flexDirection: 'row',
                    height: '100%',
                    width:'100%',                    
                    background: 'var(--gray-0)'
                }}
            >
                {loading ? (
                    <LoadingIconCenter className="fa fa-spinner fa-spin fa-4x" aria-hidden="true" />
                ) : (
                    <>
                        {!!errorsRow ? (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '200px',
                                    height: '100%',
                                    border: 'solid 1px red',
                                    flexDirection: 'column'
                                }}
                            >
                                <ErrorRowHeader />
                                <ErrorRow errros={errorsRow} />
                            </div>
                        ) : null}
                        <div
                            style={{
                                
                            }}
                        >
                            <div
                                style={{
                                    overflowX: 'scroll',
                                    overflowY: 'auto',
                                    height:"100%", 
                                    display: !!errorsRow ? 'none' : 'block'
                                }}
                            >
                                <Table
                                    data={data}
                                    header={headers}
                                    onlyView={onlyView}
                                    update={update}
                                    headerConfig={headerConfig}
                                    setHeader={header => {
                                        const newDatabase = {
                                            ...model,
                                            headers: header
                                        } as Database
                                        
                                        setDatabase(newDatabase)
                                    }}
                                />
                            </div>                            
                        </div>
                    </>
                )}
            </div>
        </>
    )
}

const Button = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 27px;

    color: white;

    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;

    border: none;

    background: #37a3ef;
    border-radius: 3px;
`
const Li = styled.li<{
    selected: boolean
}>`
    background: ${({ selected }) => (selected ? ' #ffffff' : '#dddee1')};
`
const Sheets = styled.ul`
    // margin-top: 10px;
    background: #eeeeee;
    white-space: nowrap;
    height: 40px;
    margin: 0 !important;
    display: flex;
    align-items: center;

    ${Li} {
        width: 131px;
        // height: 30px;
        height: 100%;
        font-size: 13px;
        text-align: center;
        color: #364159;

        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 4px 20px 6.9px 20px;
        border-top: 3px solid #eeeeee;
        border-right: 3px solid #eeeeee;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
            background: #949494;
            cursor: hand;
        }
    }
`
